export default {
  hero: {
    eyebrow: {
      zh: 'CSGCT 创新之星',
      en: 'CSGCT Innovation Awards',
    },
    title: {
      zh: '发现并展示全球 CGT 创新企业力量',
      en: 'Discover and showcase the most promising innovators in global CGT.',
    },
    desc: {
      zh: '面向全球细胞与基因治疗领域创新药企业，发现并展示具有创新潜力的 CGT 企业力量。',
      en: 'Open to innovative companies in cell and gene therapy worldwide, the awards spotlight CGT enterprises with strong innovation potential.',
    },
    buttons: {
      apply: {
        zh: '立即申报',
        en: 'Apply Now',
      },
      condition: {
        zh: '查看申报条件',
        en: 'View Eligibility',
      },
      contact: {
        zh: '联系组委会',
        en: 'Contact Committee',
      },
    },
  },
  about: {
    title: {
      zh: '关于 CSGCT 创新之星',
      en: 'About The CSGCT Innovation Awards',
    },
    paragraphs: [
      {
        zh: 'CSGCT 创新之星面向细胞治疗、基因治疗、基因编辑、RNA 治疗及相关 CGT 创新药企业开放。奖项通过推荐制与自主申报制相结合，鼓励更多具有创新管线、技术平台、临床进展、融资进展或 BD 合作进展的企业参与展示与交流。',
        en: 'The CSGCT Innovation Awards are open to innovative companies in cell therapy, gene therapy, gene editing, RNA therapeutics, and related CGT drug development. The program combines nomination and open application to encourage companies with innovative pipelines, technology platforms, clinical progress, financing updates, or BD collaboration milestones to participate and gain visibility.',
      },
      {
        zh: '该奖项不仅是荣誉展示，也将通过网络投票、媒体传播、大会现场颁奖、路演和 BD 对接等方式，帮助创新企业获得更多行业关注与合作机会。',
        en: 'Beyond recognition, the awards provide online voting exposure, media communication, on-site ceremony visibility, roadshow opportunities, and BD matchmaking to help innovative companies gain wider industry attention and collaboration opportunities.',
      },
    ],
  },
  eligibility: {
    title: {
      zh: '谁可以申报',
      en: 'Who Can Apply',
    },
    items: [
      {
        icon: 'enterprise',
        title: {
          zh: 'CGT 相关企业',
          en: 'CGT-Related Companies',
        },
        desc: {
          zh: '主营业务与细胞治疗、基因治疗、基因编辑、RNA 治疗或相关 CGT 创新药资产直接相关。',
          en: 'The company should be directly engaged in cell therapy, gene therapy, gene editing, RNA therapeutics, or related CGT innovation assets.',
        },
      },
      {
        icon: 'innovation',
        title: {
          zh: '具备创新基础',
          en: 'Innovation Evidence',
        },
        desc: {
          zh: '拥有可公开说明的技术平台、核心管线、临床进展、注册申报、融资、BD 或合作进展之一。',
          en: 'The company should have at least one publicly describable innovation proof point, such as a technology platform, pipeline, clinical progress, regulatory filing, financing, BD, or collaboration milestone.',
        },
      },
      {
        icon: 'trust',
        title: {
          zh: '合规可信',
          en: 'Compliance and Credibility',
        },
        desc: {
          zh: '无明显重大合规风险、诚信风险或公开重大负面事件。',
          en: 'The company should have no material compliance issues, integrity risks, or major public negative events.',
        },
      },
      {
        icon: 'material',
        title: {
          zh: '可提供基础材料',
          en: 'Basic Materials Ready',
        },
        desc: {
          zh: '可提交公司简介、创新说明、融资轮次、最新里程碑和联系人信息。',
          en: 'The company should be able to provide a company profile, innovation summary, financing stage, latest milestones, and contact information.',
        },
      },
    ],
  },
  applyTypes: {
    title: {
      zh: '申报方式',
      en: 'Application Methods',
    },
    items: [
      {
        title: {
          zh: '推荐制',
          en: 'Nomination',
        },
        desc: [
          {
            zh: '由 CSGCT 秘书处、主席团、理事会及合作方推荐 CGT 领域创新企业。',
            en: 'Innovative CGT companies may be nominated by the CSGCT Secretariat, Presidium, Council, or ecosystem partners.',
          },
          {
            zh: '被推荐企业填写申报材料，经组委会确认后进入入围流程。',
            en: 'Nominated companies submit their application materials and enter the shortlist process after committee confirmation.',
          },
        ],
      },
      {
        title: {
          zh: '自主申报制',
          en: 'Open Application',
        },
        desc: [
          {
            zh: '未在推荐名单中的企业可自主申报。',
            en: 'Companies not included in the nomination list may apply directly.',
          },
          {
            zh: '企业需填写申报材料，由专家进行初步评估，符合条件后获得入围资格。',
            en: 'Applicants submit materials for preliminary expert review and may be shortlisted upon meeting the requirements.',
          },
        ],
      },
    ],
  },
  materials: {
    title: {
      zh: '申报材料',
      en: 'Application Materials',
    },
    intro: {
      zh: '请准备以下信息并完成表格填写提交，附件为可选项。',
      en: 'Please prepare the following information and complete the submission form. Attachments are optional.',
    },
    items: [
      {
        label: { zh: '公司全称', en: 'Company Full Name' },
      },
      {
        label: { zh: '公司简称', en: 'Company Short Name' },
        note: {
          zh: '用于奖杯制作和对外宣传',
          en: 'Used for trophy engraving and public communications',
        },
      },
      {
        label: { zh: '联系人姓名', en: 'Contact Name' },
      },
      {
        label: { zh: '联系人职务', en: 'Contact Title' },
      },
      {
        label: { zh: '联系人手机', en: 'Contact Mobile' },
      },
      {
        label: { zh: '邮箱', en: 'Email' },
      },
      {
        label: { zh: '公司简介', en: 'Company Introduction' },
        note: {
          zh: '介绍核心管线或技术平台',
          en: 'Include core pipeline or platform introduction',
        },
      },
      {
        label: { zh: '创新说明', en: 'Innovation Statement' },
        note: {
          zh: '500 字以内，请用可公开、易理解的语言说明创新点，可用于官网展示、投票页、公众号及媒体宣传。',
          en: 'Within 500 words. Please describe the innovation in public-friendly and easy-to-understand language. This content may be used on the official website, voting pages, official social channels, and media coverage.',
        },
      },
      {
        label: { zh: '最新里程碑', en: 'Latest Milestones' },
        note: {
          zh: '可填写临床进展、申报注册、融资、BD 或合作进展',
          en: 'Such as clinical progress, regulatory filings, financing, BD, or partnership updates',
        },
      },
      {
        label: { zh: '公司 Logo', en: 'Company Logo' },
        note: {
          zh: '图片格式',
          en: 'Image format',
        },
      },
      {
        label: { zh: '附件（可选）', en: 'Attachment (Optional)' },
      },
    ],
    exampleTitle: {
      zh: '创新说明示例',
      en: 'Innovation Statement Example',
    },
    example: {
      zh: '我们正在解决【疾病 / 适应症 / 技术难题】中的【具体痛点】。公司基于【核心技术平台 / 产品管线】，通过【技术路径 / 作用机制 / 工艺 / 递送 / 临床策略】实现创新。目前已取得【IND / 临床阶段 / 数据 / 论文 / 专利 / 融资 / 合作】等进展。该创新有望为【患者 / 医生 / 行业】带来【疗效、安全性、可及性、生产效率、成本、国际合作】等方面的价值。',
      en: 'We are addressing a specific pain point within a disease area, indication, or technical challenge. Based on our core platform or pipeline, we innovate through technology pathway, mechanism of action, process, delivery, or clinical strategy. We have already achieved progress in areas such as IND filing, clinical stage, data generation, publications, patents, financing, or partnerships. This innovation is expected to create value for patients, physicians, and the industry in efficacy, safety, accessibility, manufacturing efficiency, cost, or global collaboration.',
    },
  },
  benefits: {
    title: {
      zh: '相关权益',
      en: 'Benefits and Recognition',
    },
    items: [
      {
        title: {
          zh: '入围企业将获得',
          en: 'Shortlisted Companies Will Receive',
        },
        list: [
          {
            zh: '网络投票期间优秀企业集合宣传权益；',
            en: 'Exposure in curated promotional collections during the online voting period;',
          },
          {
            zh: '2 张 CSGCT 大会 VIP 门票，限总监及以上人员使用；',
            en: 'Two CSGCT conference VIP tickets for director-level executives and above;',
          },
          {
            zh: 'VIP 考察团享受成团优惠价。',
            en: 'Group preferential pricing for participation in the VIP delegation program.',
          },
        ],
      },
      {
        title: {
          zh: '获奖企业将获得',
          en: 'Winning Companies Will Receive',
        },
        list: [
          {
            zh: '“CSGCT 创新之星”专属奖杯；',
            en: 'An exclusive CSGCT Innovation Awards trophy;',
          },
          {
            zh: 'CSGCT 公众号、官网及合作媒体发布；',
            en: 'Featured exposure on the CSGCT official account, website, and partner media;',
          },
          {
            zh: 'CSGCT 路演专场优先参与资格；',
            en: 'Priority access to dedicated CSGCT roadshow sessions;',
          },
          {
            zh: 'BD 对接推荐及 CGT 海外 BD 资源对接会优先参与权。',
            en: 'Priority access to BD matchmaking recommendations and overseas CGT BD networking sessions.',
          },
        ],
      },
    ],
  },
  timeline: {
    title: {
      zh: '活动流程',
      en: 'Program Timeline',
    },
    stages: [
      {
        short: { zh: '申报期', en: 'Application' },
        time: { zh: '6 月 15 日 - 7 月 15 日', en: 'Jun 15 - Jul 15' },
        title: { zh: '申报期', en: 'Application Period' },
        desc: {
          zh: '启动宣传招募，开放企业申报。',
          en: 'Promotion and recruitment launch, with applications open to companies.',
        },
      },
      {
        short: { zh: '入围确认期', en: 'Shortlist' },
        time: { zh: '7 月 15 日 - 7 月 20 日', en: 'Jul 15 - Jul 20' },
        title: { zh: '入围确认期', en: 'Shortlist Confirmation' },
        desc: {
          zh: '确认入围名单。',
          en: 'The shortlist is reviewed and confirmed.',
        },
      },
      {
        short: { zh: '投票期', en: 'Voting' },
        time: { zh: '7 月 20 日 - 8 月 10 日', en: 'Jul 20 - Aug 10' },
        title: { zh: '投票期', en: 'Voting Period' },
        desc: {
          zh: '网络投票及入围企业宣传。',
          en: 'Online voting and visibility promotion for shortlisted companies.',
        },
      },
      {
        short: { zh: '评审确认期', en: 'Final Review' },
        time: { zh: '8 月 10 日 - 8 月 15 日', en: 'Aug 10 - Aug 15' },
        title: { zh: '评审确认期', en: 'Final Review Confirmation' },
        desc: {
          zh: '组委会与主席团最终确认获奖名单。',
          en: 'The committee and presidium finalize the list of winners.',
        },
      },
      {
        short: { zh: '获奖公布期', en: 'Announcement' },
        time: { zh: '8 月 16 日', en: 'Aug 16' },
        title: { zh: '获奖公布期', en: 'Winner Announcement' },
        desc: {
          zh: '正式公布获奖企业名单。',
          en: 'Official public announcement of the winning companies.',
        },
      },
    ],
  },
}
